function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 5px 10px;\n  margin: 5px;\n  border-radius: 6px;\n  width: ", ";\n  box-shadow: 4px 4px 10px #33333326, -2px -2px 10px #33333326;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { defaultTheme } from '../../../utils';
var PopoverContainer = styled.div(_templateObject(), function (props) {
  return props.width;
});

var Popover = function Popover(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      width = _ref.width;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/React.createElement(PopoverContainer, {
    width: width
  }, children));
};

Popover.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: PropTypes.bool.isRequired,
  width: PropTypes.string,
  children: PropTypes.node
} : {};
Popover.defaultProps = {
  isOpen: false,
  width: '20%',
  theme: defaultTheme
};
export default Popover;